module.exports = __webpack_public_path__ + "img/logo.ba866eea.png";